import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';

export class ModalCloseComponent {
    constructor() {
        this.componentName = "modalCloseComponent";
        this.template = `
    <div class="modal fade show" style="display: block" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{title}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span onClick="_cmp.modalClose.close()" aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
          {msg}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" onClick="_cmp.modalClose.close()" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    `;
    }


	
	render(title, msg) {
		var tpl = this.template;
		tpl = tpl.replace("{title}", title);
		tpl = tpl.replace("{msg}", msg);
    document.body.classList.add("model-open");
		_svc.util.html("#" + this.componentName, tpl);
		
	}
	
	close() {
    _svc.util.html("#" + this.componentName, "");
    document.body.classList.remove("model-open");
	}
}

setTimeout(() => {
   _cmp.modalClose = new ModalCloseComponent(); 
}, 1);